import 'url-search-params-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import menu from './modules/menu'
import user from './modules/user'
import info from './modules/info'
import prompt from './modules/prompt'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    menu,
    user,
    info,
    prompt
  }
})
